import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=37333f92&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=37333f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37333f92",
  null
  
)

export default component.exports